import { useSelector } from 'react-redux';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';

export const useGetCampaignInfo = () => {
    const { campaign, activeTemplateIndex } = useSelector(getCampainCreatorStore);

    const campaignTemplate = campaign?.CampaignTemplates?.[activeTemplateIndex];

    const subject = campaignTemplate?.Body?.Subject ?? '';
    const fromName = campaignTemplate?.Sender?.FromName ?? '';
    const fromEmail = campaignTemplate?.Sender?.From?.[0] ?? '';
    const replyName = campaignTemplate?.Sender?.ReplyName ?? '';
    const replyEmail = campaignTemplate?.Sender?.ReplyTo?.[0] ?? '';
    const template = campaignTemplate?.TemplateName;
    const previewText = campaignTemplate?.Body?.PreHeader ?? '';

    return { subject, fromEmail, fromName, replyEmail, replyName, template, previewText };
};
